import React from 'react';
import { Box } from 'oskcomponents';
import { useNavigate } from 'react-router-dom';

export type BreadcrumbNodeProps = {
    title: string;
    url?: string;
};

const BreadcrumbNode = ({ title, url }: BreadcrumbNodeProps) => {
    const navigate = useNavigate();
    return (
        <Box
            style={{ paddingRight: '4px', textDecoration: url ? 'underline' : 'none' }}
            {...(url && { onClick: () => navigate(url) })}
        >
            {title}
        </Box>
    );
};

const BreadcrumbDivider = () => <Box style={{ padding: '0px 6px 0px 6px' }}>/</Box>;

export type BreadcrumbProps = {
    nodes?: Array<BreadcrumbNodeProps>;
};

export const Breadcrumb = ({ nodes }: BreadcrumbProps) => {
    return (
        <React.Fragment>
            {nodes && (
                <Box>
                    {nodes.map((node, idx) => (
                        <React.Fragment key={`breadcrumb_${node.title}_${idx}`}>
                            <BreadcrumbNode {...node} />
                            {idx < nodes.length - 1 && <BreadcrumbDivider />}
                        </React.Fragment>
                    ))}
                </Box>
            )}
        </React.Fragment>
    );
};
